const CONFIG_PATH = '/config.json';

interface Config {
    [key: string]: any;

    appName?: string;
    appVersion?: string;
    apiBaseUrl?: string;
    keycloakUrl?: string;
    keycloakRealm?: string;
    keycloakClientId?: string;
    notificationWs?: string;
    /** Внешний portal апгрейда тарифа (deep-link). Встроенной оплаты нет — ведём наружу (CTHS-21). */
    upgradePortalUrl?: string;
}

// Значения по умолчанию для разработки
const defaultConfig: Config = {
    appName: 'Clothes app',
    appVersion: 'SNAPSHOT',
    // Same-origin relative URLs: in dev they go through the CRA proxy (src/setupProxy.js) to
    // the backend, in prod through the ingress. Keeping the API same-origin as the SPA is what
    // lets the httpOnly SameSite=Strict auth cookies be sent on every request.
    apiBaseUrl: '/api',
    keycloakUrl: 'https://auth.forwolk.ru',
    keycloakRealm: 'develop',
    keycloakClientId: 'clothes-app',
    notificationWs: '/api/ws/notifications',
    upgradePortalUrl: 'https://forwolk.ru/clothes/upgrade'
};

let config: Config = {...defaultConfig};
let configLoaded = false;

export const loadConfig = async (): Promise<void> => {
    try {
        const response = await fetch(CONFIG_PATH);
        if (response.ok) {
            const loadedConfig = await response.json();
            config = {...defaultConfig, ...loadedConfig};
            configLoaded = true;
            console.log('Configuration loaded successfully');
        } else {
            console.warn(`Failed to load config from ${CONFIG_PATH}, using defaults`);
            config = {...defaultConfig};
        }
    } catch (error) {
        console.warn(`Error loading config from ${CONFIG_PATH}, using defaults:`, error);
        config = {...defaultConfig};
    }
};

export const getConfig = (key: string): any => {
    if (!configLoaded) {
        console.warn(`Config not loaded yet, returning default value for ${key}`);
    }
    return config[key] || defaultConfig[key];
};

export const isConfigLoaded = (): boolean => configLoaded;
